import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addPilotChargeData,
  deletePilotChargeData,
  fetchPilotChargeList,
  updatePilotChargeData,
} from "../../apis/pilotCharge";

export const fetchPilotCharges = createAsyncThunk(
  "pilotCharges/fetchPilotChargesData",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchPilotChargeList();
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.pilotCharge.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updatePilotCharge = createAsyncThunk(
  "pilotCharges/updatePilotCharge",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        pilotChargeId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updatePilotChargeData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deletePilotCharge = createAsyncThunk(
  "pilotCharges/deletePilotCharge",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deletePilotChargeData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewPilotChargeData = createAsyncThunk(
  "pilotCharges/addNewPilotCharge",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addPilotChargeData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
